import { z } from "zod";

export const WebhookEvent = {
	MEMBER_JOINED: "member.joined",
	MEMBER_APPROVED: "member.approved",
	MEMBER_BANNED: "member.banned",
	EVENT_CREATED: "event.created",
	EVENT_REGISTRATION_CREATED: "event.registration.created",
	EVENT_REGISTRATION_CANCELLED: "event.registration.cancelled",
	MEETING_STARTED: "meeting.started",
	MEETING_ENDED: "meeting.ended",
} as const;

export type WebhookEvent = (typeof WebhookEvent)[keyof typeof WebhookEvent];

export const WEBHOOK_EVENTS: WebhookEvent[] = Object.values(WebhookEvent);

export const webhookEventSchema = z.enum(WEBHOOK_EVENTS);
